import { Exercise, SwedishTask, DailyRecord, AppState, FoodItem, CustomActivity, AppNotificationSetting, WeeklyRoutineTask, AppSettings } from '../types';
import { getStoredUser, apiGet, apiPost, apiPut, apiDelete } from './api';
import { notifyPlannerChanged } from './plannerClient';

// Standard Rehab Exercises List (Physiotherapeutic Decompression - Videos 1 & 2)
export const DEFAULT_REHAB_EXERCISES: Exercise[] = [
  {
    id: 'rehab_single_leg_bridge_left',
    name: 'پل تک پا - پای چپ (Single Leg Bridge - Left)',
    category: 'rehab',
    description: 'به پشت دراز بکشید، زانوها را خم کرده و کف پاها را روی زمین بگذارید. پای راست را صاف به جلو بکشید. حالا با فشار به پاشنه پای چپ، باسن و لگن را از زمین بلند کنید تا تراز زانو تا شانه کاملاً صاف شود.',
    purpose: 'تقویت یک‌طرفه زنجیره خلفی و پایدارکننده‌های لگن؛ رفع عدم تقارن عضلانی آسیب‌رسان به دیسک کمر.',
    targetMuscles: 'سرینی بزرگ سمت چپ، همسترینگ چپ، عضلات پایدارکننده کور',
    sets: 3,
    reps: '۱۰ تکرار (۳ ثانیه مکث در اوج)',
    rest: '۲۰ ثانیه',
    duration: 3,
    difficulty: 'Intermediate'
  },
  {
    id: 'rehab_single_leg_bridge_right',
    name: 'پل تک پا - پای راست (Single Leg Bridge - Right)',
    category: 'rehab',
    description: 'به پشت دراز بکشید، زانوها را خم کرده و کف پاها را روی زمین بگذارید. پای چپ را صاف به جلو بکشید. حالا با فشار به پاشنه پای راست، باسن و لگن را از زمین بلند کنید تا تراز زانو تا شانه کاملاً صاف شود.',
    purpose: 'تقویت یک‌طرفه عضلات سرینی سمت راست برای رفع عدم تقارن لگنی و کاهش فشارهای برشی بر دیسک مهره‌ای.',
    targetMuscles: 'سرینی بزرگ سمت راست، همسترینگ راست، پایدارکننده‌های عمقی لگن',
    sets: 3,
    reps: '۱۰ تکرار (۳ ثانیه مکث در اوج)',
    rest: '۲۰ ثانیه',
    duration: 3,
    difficulty: 'Intermediate'
  },
  {
    id: 'rehab_side_plank_hip_lift_left',
    name: 'بلند کردن لگن در ساید پلانک - سمت چپ (Side Plank Hip Lift - Left)',
    category: 'rehab',
    description: 'روی پهلوی چپ دراز بکشید و روی ساعد چپ تکیه کنید (آرنج دقیقاً زیر شانه). زانوها را ۹۰ درجه خم کنید. لگن را به آرامی از زمین بلند کرده، بدن را کاملاً در یک راستا تراز کنید، ۳ ثانیه مکث کنید و کنترل‌شده پایین بیاورید.',
    purpose: 'تقویت عضله مربع کمری (Quadratus Lumborum) سمت چپ و بهبود ثبات جانبی مهره‌ها.',
    targetMuscles: 'عضله مربع کمری چپ، مایل شکمی، سرینی متوسط',
    sets: 3,
    reps: '۸ تا ۱۰ تکرار بسیار آرام',
    rest: '۲۰ ثانیه',
    duration: 3,
    difficulty: 'Intermediate'
  },
  {
    id: 'rehab_side_plank_hip_lift_right',
    name: 'بلند کردن لگن در ساید پلانک - سمت راست (Side Plank Hip Lift - Right)',
    category: 'rehab',
    description: 'روی پهلوی راست دراز بکشید و روی ساعد راست تکیه کنید (آرنج دقیقاً زیر شانه). زانوها را ۹۰ درجه خم کنید. لگن را به آرامی از زمین بلند کرده، بدن را کاملاً در یک راستا تراز کنید، ۳ ثانیه مکث کنید و کنترل‌شده پایین بیاورید.',
    purpose: 'تقویت عضله مربع کمری سمت راست جهت برقراری تقارن و پایداری در ستون فقرات پشتی-خاجی.',
    targetMuscles: 'عضله مربع کمری راست، مایل شکمی، سرینی متوسط',
    sets: 3,
    reps: '۸ تا ۱۰ تکرار بسیار آرام',
    rest: '۲۰ ثانیه',
    duration: 3,
    difficulty: 'Intermediate'
  },
  {
    id: 'rehab_bird_dog',
    name: 'حرکت سگ-پرنده (Bird Dog)',
    category: 'rehab',
    description: 'به صورت چهار دست و پا روی زمین قرار بگیرید. دست راست و پای چپ را به طور همزمان به موازات زمین صاف کرده و بکشید تا با بدن هم‌تراز شوند. ۵ ثانیه مکث کنید، به آرامی بازگردید و سپس برای سمت مخالف تکرار کنید.',
    purpose: 'اصولی‌ترین تمرین زنجیره متقاطع شکمی-پشتی برای ایجاد ثبات چندسویه بدون تحمیل فشار بر دیسک.',
    targetMuscles: 'عضله مولتی‌فیدوس، راست‌کننده ستون فقرات، سرینی بزرگ، شکم',
    sets: 3,
    reps: '۱۲ تکرار متناوب (۶ تکرار هر طرف)',
    rest: '۲۰ ثانیه',
    duration: 3,
    difficulty: 'Beginner'
  },
  {
    id: 'rehab_plank',
    name: 'پلانک شکم (Plank)',
    category: 'rehab',
    description: 'روی ساعدها و پنجه‌های پا قرار بگیرید. بدن را کاملاً صاف و در یک خط مستقیم نگه دارید. عضلات شکم و باسن را منقبض کرده و از گود شدن یا بالا رفتن باسن به شدت خودداری کنید.',
    purpose: 'تقویت دیواره قدامی شکم و عضلات کور جهت ایجاد کمربند ایمنی طبیعی دور ستون فقرات.',
    targetMuscles: 'راست شکمی، مایل شکمی، عضلات عمقی شکم (Transversus)',
    sets: 3,
    reps: '۳۰ تا ۴۵ ثانیه حفظ موقعیت',
    rest: '۳۰ ثانیه',
    duration: 3,
    difficulty: 'Intermediate'
  },
  {
    id: 'rehab_upper_circle_crunch',
    name: 'کرانچ دایره‌ای فوقانی (Upper Circle Crunch)',
    category: 'rehab',
    description: 'به پشت دراز بکشید و زانوها را خم کنید. دست‌ها را پشت سر بگذارید. سر و شانه را کمی از زمین جدا کنید و یک قوس دایره‌ای ملایم به سمت چپ و سپس راست بکشید، سپس پایین بروید. گودی کمر نباید از زمین جدا شود.',
    purpose: 'فعال‌سازی عضلات بالای شکم و مورب بدون ایجاد هرگونه انحنای دردناک یا آسیب‌رسان در پایین کمر.',
    targetMuscles: 'بخش فوقانی راست شکمی، مایل خارجی شکم',
    sets: 3,
    reps: '۱۲ تکرار کنترل‌شده با تمرکز عمیق',
    rest: '۲۰ ثانیه',
    duration: 3,
    difficulty: 'Intermediate'
  },
  {
    id: 'rehab_reverse_crunch',
    name: 'کرانچ معکوس کنترل‌شده (Reverse Crunch)',
    category: 'rehab',
    description: 'به پشت بخوابید و زانوها را ۹۰ درجه در هوا نگه دارید. دست‌ها کنار بدن. با انقباض عضلات زیر شکم، لگن را به نرمی ۲ الی ۵ سانتی‌متر از زمین بلند کنید و آرام پایین بیاورید. از پرتاب پا خودداری کنید.',
    purpose: 'تقویت تخصصی عضلات زیر شکم و چرخش خلفی لگن (Posterior Pelvic Tilt) برای کاهش گودی مفرط کمر.',
    targetMuscles: 'راست شکمی (به‌ویژه بخش پایینی)، عضلات عمیق لگنی',
    sets: 3,
    reps: '۱۰ تکرار بسیار آرام و قدرتی',
    rest: '۲۵ ثانیه',
    duration: 3,
    difficulty: 'Intermediate'
  }
];

// Standard Belly Fat Reduction Exercises List (Beginner Friendly)
export const DEFAULT_FAT_LOSS_EXERCISES: Exercise[] = [
  {
    id: 'fat_march_place',
    name: 'قدم زدن درجا',
    category: 'fat-loss',
    description: 'در جای خود قدم بزنید، زانوهای خود را بالا بیاورید و دست‌ها را با ریتم تکان دهید تا ضربان قلب به طور ایمن بالا برود.',
    purpose: 'گرم کردن، افزایش نرخ متابولیسم و بهبود گردش خون.',
    targetMuscles: 'خم‌کننده‌های باسن، چهارسر ران، ساق پا',
    sets: 2,
    reps: '۶۰ ثانیه',
    rest: '۳۰ ثانیه',
    duration: 3,
    difficulty: 'Beginner',
    caloriesBurned: 18
  },
  {
    id: 'fat_knee_raises',
    name: 'بالا آوردن ایستاده زانو',
    category: 'fat-loss',
    description: 'صاف بایستید. زانوی راست خود را تا سطح باسن بالا بیاورید در حالی که عضلات شکم را منقبض می‌کنید، سپس پایین بیاورید و زانوی چپ را بالا ببرید. سرعت ثابتی را حفظ کنید.',
    purpose: 'فعال‌سازی عضلات تحتانی شکم و ارتقای تعادل در حالت ایستاده.',
    targetMuscles: 'عضله راست شکمی، باسن و ران',
    sets: 2,
    reps: '۱۵ تکرار برای هر طرف',
    rest: '۳۰ ثانیه',
    duration: 3,
    difficulty: 'Beginner',
    caloriesBurned: 15
  },
  {
    id: 'fat_heel_taps',
    name: 'لمس پاشنه پا',
    category: 'fat-loss',
    description: 'به پشت دراز بکشید و زانوها را خم کنید. دست‌های خود را به سمت پایین دراز کنید تا پاشنه راست و سپس پاشنه چپ خود را لمس کنید و عضلات مورب شکمی را منقبض کنید.',
    purpose: 'هدف قرار دادن دیواره جانبی شکم (عضلات مورب) بدون هیچ فشاری به پایین کمر.',
    targetMuscles: 'عضلات مورب، بخش بالایی شکم',
    sets: 2,
    reps: '۱۲ لمس برای هر طرف',
    rest: '۳۰ ثانیه',
    duration: 3,
    difficulty: 'Beginner',
    caloriesBurned: 12
  },
  {
    id: 'fat_modified_plank',
    name: 'پلانک اصلاح‌شده (روی زانو)',
    category: 'fat-loss',
    description: 'روی ساعدها و زانوهای خود قرار بگیرید و بدن خود را در یک خط مستقیم از سر تا زانو نگه دارید. شکم و باسن را منقبض کنید.',
    purpose: 'تقویت ایزومتریک دیواره شکم برای کاهش فشار روی کمر.',
    targetMuscles: 'عضله عرضی شکم، کمربند شانه',
    sets: 2,
    reps: '۳۰ ثانیه مکث',
    rest: '۴۵ ثانیه',
    duration: 2.5,
    difficulty: 'Beginner',
    caloriesBurned: 20
  },
  {
    id: 'fat_standing_twists',
    name: 'چرخش ایستاده کمر',
    category: 'fat-loss',
    description: 'بایستید و پاها را به اندازه عرض شانه باز کنید، آرنج‌ها را تا ارتفاع سینه بالا بیاورید. بالاتنه خود را به آرامی از طرفی به طرف دیگر بچرخانید و عضلات شکم را منقبض کنید.',
    purpose: 'بهبود تحرک خط کمر و فعال‌سازی گروه‌های عضلانی مورب شکمی.',
    targetMuscles: 'عضلات مورب، تثبیت‌کننده‌های داخلی',
    sets: 2,
    reps: '۲۰ چرخش',
    rest: '۲۰ ثانیه',
    duration: 2,
    difficulty: 'Beginner',
    caloriesBurned: 10
  },
  {
    id: 'fat_light_walking',
    name: 'پیاده‌روی سبک',
    category: 'fat-loss',
    description: 'یک پیاده‌روی آرام و با سرعت ثابت در محل یا در فضای خود داشته باشید. بر روی وضعیت قامت، سر بالا و درگیر کردن شکم تمرکز کنید.',
    purpose: 'چربی‌سوزی هوازی مداوم و ایمن و روان‌سازی مفاصل.',
    targetMuscles: 'کل بدن، سیستم قلبی عروقی',
    sets: 1,
    reps: '۱۰ دقیقه',
    rest: 'بدون استراحت',
    duration: 10,
    difficulty: 'Beginner',
    caloriesBurned: 45
  }
];

// Standard Swedish Study Topics & Subtasks
export const DEFAULT_SWEDISH_TASKS: SwedishTask[] = [
  { id: 'swe_verbs', title: 'افعال کاربردی سوئدی (Swedish Verbs)', topic: 'تسلط بر افعال حرکتی، زمان حال، گذشته و صرف افعال اصلی', duration: '۱۰-۱۵ دقیقه' },
  { id: 'swe_employee', title: 'واژگان حوزه استخدام و محیط کار (Employee / Arbete)', topic: 'اصطلاحات اداری، درخواست کار، صحبت با همکاران و کارفرما', duration: '۱۰-۱۵ دقیقه' },
  { id: 'swe_independent', title: 'مطالعه و ممارست مستقل روزانه', topic: 'ثبت و پایش یادگیری مستقل انجام‌شده در سایر اپلیکیشن‌ها', duration: '۱۰-۱۵ دقیقه' }
];

// Default Reminder Configurations
export const DEFAULT_NOTIFICATIONS: AppNotificationSetting[] = [
  { id: 'rem_rehab', title: 'ورزش اصلاحی کمردرد', time: '07:30', enabled: true, category: 'rehab' },
  { id: 'rem_belly', title: 'تمرین هوازی آب کردن چربی شکم', time: '17:00', enabled: true, category: 'fat-loss' },
  { id: 'rem_water_1', title: 'نوشیدن آب (صبح)', time: '09:00', enabled: true, category: 'water' },
  { id: 'rem_water_2', title: 'نوشیدن آب (بعد از ظهر)', time: '14:00', enabled: true, category: 'water' },
  { id: 'rem_swedish_sfi', title: 'یادآوری کلاس سوئدی', time: '17:15', enabled: true, category: 'swedish' },
  { id: 'rem_swedish_self', title: 'خودآموزی روزانه زبان سوئدی', time: '20:30', enabled: true, category: 'swedish' },
  { id: 'rem_log_day', title: 'ثبت فعالیت‌های روزانه و یادداشت‌ها', time: '21:30', enabled: true, category: 'logging' }
];

// Default Weekly Routine (Empty by default - loaded 100% directly from Cloudflare D1)
export const DEFAULT_WEEKLY_ROUTINE: WeeklyRoutineTask[] = [];

// In-Memory & D1 Data Cache Keys
const STORAGE_KEY = 'vaxa_app_state';

// Factory to create an empty DailyRecord
export function createEmptyDailyRecord(date: string): DailyRecord {
  return {
    date,
    rehabCompletedIds: [],
    fatLossCompletedIds: [],
    foods: [],
    swedishCompletedIds: [],
    wentToWork: false,
    attendedSfi: false,
    activities: [],
    notes: {
      painLevel: 0,
      mood: 'آرام',
      energyLevel: 3,
      symptoms: '',
      observations: '',
      reminders: ''
    },
    waterIntake: 0,
    sleepHours: 0,
    sleepTime: '',
    wakeTime: '',
    todos: []
  };
}

// Utility to convert English numbers to Persian/Farsi numbers when language is Persian, or standard digits for English/Swedish
export function toPersianDigits(num: string | number | undefined | null): string {
  if (num === undefined || num === null) return '';
  const str = String(num);
  try {
    const lang = (typeof document !== 'undefined' && document.documentElement?.getAttribute('lang')) || 'fa';
    if (lang === 'en' || lang === 'sv') {
      return str;
    }
  } catch (e) {}
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return str.replace(/[0-9]/g, (w) => persianDigits[parseInt(w, 10)]);
}

function initInitialState(): AppState {
  return {
    records: {},
    settings: {
      notifications: DEFAULT_NOTIFICATIONS,
      userName: 'کاربر',
      targetWater: 2000,
      targetCalories: 2200,
      weeklyRoutine: DEFAULT_WEEKLY_ROUTINE,
      rehabExercises: [],
      rehabInbox: []
    }
  };
}

let inMemoryAppState: AppState = initInitialState();

// Get entire application state from memory
export function loadAppState(): AppState {
  if (!inMemoryAppState.settings.weeklyRoutine) {
    inMemoryAppState.settings.weeklyRoutine = DEFAULT_WEEKLY_ROUTINE;
  }
  if (!inMemoryAppState.settings.rehabExercises) {
    inMemoryAppState.settings.rehabExercises = [];
  }
  if (!inMemoryAppState.settings.rehabInbox) {
    inMemoryAppState.settings.rehabInbox = [];
  }
  return inMemoryAppState;
}

let appSettingsListeners: Array<(settings: AppSettings) => void> = [];

export function subscribeToAppSettings(listener: (settings: AppSettings) => void) {
  appSettingsListeners.push(listener);
  return () => {
    appSettingsListeners = appSettingsListeners.filter(l => l !== listener);
  };
}

export function notifyAppSettingsUpdate(settings: AppSettings) {
  appSettingsListeners.forEach(l => {
    try { l(settings); } catch (e) {}
  });
}

let lastWeeklyRoutine: WeeklyRoutineTask[] = [];
let lastRehabExercises: Exercise[] = [];
let lastRehabInbox: any[] = [];

// Generic helper to diff-sync two lists via relative REST API endpoints
async function syncList<T extends { id: string }>(
  newList: T[],
  lastSyncedList: T[],
  endpoints: {
    post: (item: T) => Promise<any>;
    put: (id: string, item: T) => Promise<any>;
    delete: (id: string) => Promise<any>;
  }
) {
  const newMap = new Map(newList.map(item => [item.id, item]));
  const oldMap = new Map(lastSyncedList.map(item => [item.id, item]));

  // 1. Delete items that were removed
  for (const oldId of oldMap.keys()) {
    if (!newMap.has(oldId)) {
      await endpoints.delete(oldId).catch(err => console.warn(`Delete failed for ${oldId}:`, err));
    }
  }

  // 2. Add or update items
  for (const [newId, newItem] of newMap.entries()) {
    const oldItem = oldMap.get(newId);
    if (!oldItem) {
      await endpoints.post(newItem).catch(err => console.warn(`Add failed for ${newId}:`, err));
    } else {
      // Deep equal check
      const itemStr = JSON.stringify(newItem);
      const oldStr = JSON.stringify(oldItem);
      if (itemStr !== oldStr) {
        await endpoints.put(newId, newItem).catch(err => console.warn(`Update failed for ${newId}:`, err));
      }
    }
  }
}

// Save entire state to memory and sync directly to cloud database
export function saveAppState(state: AppState, syncToCloud: boolean = true): void {
  inMemoryAppState = state;

  notifyAppSettingsUpdate(state.settings);

  if (!syncToCloud) return;

  const currentUser = getStoredUser();
  if (!currentUser) return;

  // 1. Sync core user settings
  apiPut('/api/settings', {
    language: state.settings.language || 'fa',
    theme: state.settings.theme || 'light',
    calendar_type: state.settings.calendarType || 'solar',
    target_water: state.settings.targetWater,
    target_calories: state.settings.targetCalories,
    height_cm: state.settings.height,
    current_weight: state.settings.currentWeight,
    target_weight_kg: state.settings.weightGoal,
    target_body_fat_pct: state.settings.bodyFatGoal,
    age: state.settings.age,
    gender: state.settings.gender,
    activity_level: state.settings.activityLevel,
    weight_goal_type: state.settings.weightGoalType,
    medical_history: state.settings.medicalConditions,
    medications: state.settings.medications,
    allergies: state.settings.allergies,
    health_goals: state.settings.dietaryGoals,
    notifications_enabled: true,
    setting_data: {
      language: state.settings.language,
      theme: state.settings.theme,
      calendarType: state.settings.calendarType,
      targetWater: state.settings.targetWater,
      targetCalories: state.settings.targetCalories,
      height: state.settings.height,
      currentWeight: state.settings.currentWeight,
      weightGoal: state.settings.weightGoal,
      bodyFatGoal: state.settings.bodyFatGoal,
      age: state.settings.age,
      gender: state.settings.gender,
      activityLevel: state.settings.activityLevel,
      weightGoalType: state.settings.weightGoalType,
      medicalConditions: state.settings.medicalConditions,
      medications: state.settings.medications,
      allergies: state.settings.allergies,
      dietaryGoals: state.settings.dietaryGoals
    }
  }).catch(err => {
    console.warn('Failed auto-syncing settings to cloud:', err);
  });

  // 2. Sync Weekly Routine Items via list-diffing
  const newRoutine = state.settings.weeklyRoutine || [];
  syncList(newRoutine, lastWeeklyRoutine, {
    post: (item) => apiPost('/api/weekly-routine', {
      id: item.id,
      title: item.title,
      description: item.description || '',
      day_of_week: Number(item.dayOfWeek),
      start_time: item.time,
      end_time: item.endTime || null,
      category: item.category || 'work',
      reminder_enabled: Boolean(item.reminderEnabled),
      phone_notification_enabled: item.phoneNotificationEnabled !== false,
      went_to_work_checked: Boolean(item.wentToWorkChecked),
      attended_sfi_checked: Boolean(item.attendedSfiChecked),
      program_id: item.programId || null,
      program_day_id: item.programDayId || null,
      default_score: item.defaultScore ?? null,
      score_mode: item.scoreMode || 'auto',
      custom_score: item.customScore ?? null,
      is_required: item.isRequired !== false ? 1 : 0
    }),
    put: (id, item) => apiPut(`/api/weekly-routine/${id}`, {
      title: item.title,
      description: item.description || '',
      day_of_week: Number(item.dayOfWeek),
      start_time: item.time,
      end_time: item.endTime || null,
      category: item.category || 'work',
      reminder_enabled: Boolean(item.reminderEnabled),
      phone_notification_enabled: item.phoneNotificationEnabled !== false,
      went_to_work_checked: Boolean(item.wentToWorkChecked),
      attended_sfi_checked: Boolean(item.attendedSfiChecked),
      program_id: item.programId || null,
      program_day_id: item.programDayId || null,
      default_score: item.defaultScore ?? null,
      score_mode: item.scoreMode || 'auto',
      custom_score: item.customScore ?? null,
      is_required: item.isRequired !== false ? 1 : 0
    }),
    delete: (id) => apiDelete(`/api/weekly-routine/${id}`)
  }).then(() => {
    lastWeeklyRoutine = JSON.parse(JSON.stringify(newRoutine));
  }).catch(() => {});

  // 3. Sync Rehab Exercises via list-diffing
  const newExercises = (state.settings.rehabExercises || []).filter(e => e.isCustom);
  const oldExercises = lastRehabExercises.filter(e => e.isCustom);
  syncList(newExercises, oldExercises, {
    post: (item) => apiPost('/api/rehab/exercises', {
      id: item.id,
      name: item.name,
      category: item.category || 'rehab',
      description: item.description || '',
      purpose: item.purpose || '',
      target_muscles: item.targetMuscles || '',
      sets: item.sets || 3,
      reps: item.reps !== undefined && item.reps !== null ? String(item.reps) : '10',
      rest_time: item.rest !== undefined && item.rest !== null ? String(item.rest) : '20',
      duration_minutes: item.duration || 5,
      difficulty: item.difficulty || 'Beginner',
      image_url: item.image || null,
      video_url: item.videoUrl || null
    }),
    put: (id, item) => apiPut(`/api/rehab/exercises/${id}`, {
      name: item.name,
      category: item.category || 'rehab',
      description: item.description || '',
      purpose: item.purpose || '',
      target_muscles: item.targetMuscles || '',
      sets: item.sets || 3,
      reps: item.reps !== undefined && item.reps !== null ? String(item.reps) : '10',
      rest_time: item.rest !== undefined && item.rest !== null ? String(item.rest) : '20',
      duration_minutes: item.duration || 5,
      difficulty: item.difficulty || 'Beginner',
      image_url: item.image || null,
      video_url: item.videoUrl || null
    }),
    delete: (id) => apiDelete(`/api/rehab/exercises/${id}`)
  }).then(() => {
    lastRehabExercises = JSON.parse(JSON.stringify(state.settings.rehabExercises || []));
  }).catch((err) => {
    console.warn('Failed syncing rehab exercises diff:', err);
  });

  // 4. Sync Rehab Inbox via list-diffing
  const newInbox = state.settings.rehabInbox || [];
  syncList(newInbox, lastRehabInbox, {
    post: (item) => apiPost('/api/rehab/inbox', item),
    put: (id, item) => apiPut(`/api/rehab/inbox/${id}`, item),
    delete: (id) => apiDelete(`/api/rehab/inbox/${id}`)
  }).then(() => {
    lastRehabInbox = JSON.parse(JSON.stringify(newInbox));
  }).catch(() => {});
}

// Sync app settings and child lists directly from canonical cloud REST APIs
export async function syncSettingsFromCloud(targetUid?: string): Promise<void> {
  const currentUser = getStoredUser();
  if (!currentUser) return;

  try {
    const current = loadAppState();

    // 1. Fetch core user settings
    const settingsRes = await apiGet('/api/settings');
    if (settingsRes.success && settingsRes.data) {
      const d = settingsRes.data;
      const s = d.settings || d.setting_data || {};
      current.settings = {
        ...current.settings,
        language: d.language || s.language || current.settings.language,
        theme: d.theme || s.theme || current.settings.theme,
        calendarType: d.calendar_type || s.calendarType || current.settings.calendarType,
        targetWater: Number(d.target_water ?? s.targetWater ?? 2000),
        targetWaterMl: Number(d.target_water ?? s.targetWaterMl ?? 2000),
        targetCalories: Number(d.target_calories ?? s.targetCalories ?? 2200),
        height: d.height_cm ?? d.height ?? s.height ?? current.settings.height,
        currentWeight: d.current_weight ?? d.currentWeight ?? s.currentWeight ?? current.settings.currentWeight,
        weightGoal: d.target_weight_kg ?? d.weightGoal ?? s.weightGoal ?? current.settings.weightGoal,
        bodyFatGoal: d.target_body_fat_pct ?? d.bodyFatGoal ?? s.bodyFatGoal ?? current.settings.bodyFatGoal,
        age: d.age ?? s.age ?? current.settings.age,
        gender: d.gender ?? s.gender ?? current.settings.gender,
        activityLevel: d.activity_level ?? d.activityLevel ?? s.activityLevel ?? current.settings.activityLevel,
        weightGoalType: d.weight_goal_type ?? d.weightGoalType ?? s.weightGoalType ?? current.settings.weightGoalType,
        medicalConditions: d.medical_history ?? d.medicalConditions ?? s.medicalConditions ?? current.settings.medicalConditions,
        medications: d.medications ?? s.medications ?? current.settings.medications,
        allergies: d.allergies ?? s.allergies ?? current.settings.allergies,
        dietaryGoals: d.health_goals ?? d.dietaryGoals ?? s.dietaryGoals ?? current.settings.dietaryGoals,
      };
      saveAppState(current, false);
      notifyAppSettingsUpdate(current.settings);
    }

    // 2. Fetch weekly routine items
    const routineRes = await apiGet('/api/weekly-routine');
    if (routineRes.success && Array.isArray(routineRes.data)) {
      const routineItems = routineRes.data.map((r: any) => ({
        id: r.id,
        title: r.title,
        description: r.description || '',
        dayOfWeek: Number(r.day_of_week),
        time: r.start_time,
        endTime: r.end_time || undefined,
        category: r.category || 'work',
        reminderEnabled: Boolean(r.reminder_enabled),
        phoneNotificationEnabled: Boolean(r.phone_notification_enabled),
        wentToWorkChecked: Boolean(r.went_to_work_checked),
        attendedSfiChecked: Boolean(r.attended_sfi_checked),
        programId: r.program_id || r.programId || undefined,
        programDayId: r.program_day_id || r.programDayId || undefined,
        defaultScore: r.default_score !== null && r.default_score !== undefined ? Number(r.default_score) : (r.defaultScore !== null && r.defaultScore !== undefined ? Number(r.defaultScore) : undefined),
        scoreMode: r.score_mode || r.scoreMode || 'auto',
        customScore: r.custom_score !== null && r.custom_score !== undefined ? Number(r.custom_score) : (r.customScore !== null && r.customScore !== undefined ? Number(r.customScore) : null),
        isRequired: r.is_required !== 0 && r.isRequired !== false
      }));
      current.settings.weeklyRoutine = routineItems;
      lastWeeklyRoutine = JSON.parse(JSON.stringify(routineItems));
    }

    // 3. Fetch rehab exercises (system templates + user custom exercises)
    const rehabRes = await apiGet('/api/rehab/exercises');
    if (rehabRes.success && Array.isArray(rehabRes.data)) {
      const exercises = rehabRes.data.map((r: any) => ({
        id: r.id,
        name: r.name,
        category: r.category || 'rehab',
        description: r.description || '',
        purpose: r.purpose || '',
        targetMuscles: r.targetMuscles || r.target_muscles || '',
        sets: Number(r.sets ?? 3),
        reps: r.reps !== null && r.reps !== undefined ? String(r.reps) : '10',
        rest: r.rest !== null && r.rest !== undefined ? String(r.rest) : (r.rest_time !== null && r.rest_time !== undefined ? String(r.rest_time) : '20'),
        duration: Number(r.duration || r.duration_minutes || 5),
        difficulty: r.difficulty || 'Beginner',
        image: r.image || r.image_url || null,
        videoUrl: r.videoUrl || r.video_url || null,
        isCustom: Boolean(r.isCustom || r.is_custom)
      }));
      current.settings.rehabExercises = exercises;
      lastRehabExercises = JSON.parse(JSON.stringify(exercises));
    }

    // 4. Fetch rehab inbox items
    const inboxRes = await apiGet('/api/rehab/inbox');
    if (inboxRes.success && Array.isArray(inboxRes.data)) {
      current.settings.rehabInbox = inboxRes.data;
      lastRehabInbox = JSON.parse(JSON.stringify(inboxRes.data));
    }

    // 5. Fetch exercise programs
    const progRes = await apiGet('/api/rehab/programs');
    if (progRes.success && Array.isArray(progRes.data)) {
      current.settings.exercisePrograms = progRes.data;
      const activeProg = progRes.data.find((p: any) => p.isActive);
      if (activeProg) {
        current.settings.activeProgramId = activeProg.id;
      }
    }

    saveAppState(current, false); // Update memory state
    notifyAppSettingsUpdate(current.settings);
    notifyPlannerChanged();
  } catch (err) {
    console.warn('Failed syncing settings from cloud:', err);
    throw err;
  }
}

// Fetch single record with safe fallback
export function getDailyRecord(date: string): DailyRecord {
  const state = loadAppState();
  if (!state.records[date]) {
    state.records[date] = createEmptyDailyRecord(date);
    saveAppState(state, false);
  }
  return state.records[date];
}

let dailyRecordListeners: Array<(record: DailyRecord) => void> = [];

export function subscribeToDailyRecord(listener: (record: DailyRecord) => void) {
  dailyRecordListeners.push(listener);
  return () => {
    dailyRecordListeners = dailyRecordListeners.filter(l => l !== listener);
  };
}

export function notifyDailyRecordUpdate(record: DailyRecord) {
  dailyRecordListeners.forEach(l => {
    try { l(record); } catch (e) {}
  });
}

export async function syncDailyRecordFromCloud(dateStr: string): Promise<DailyRecord | null> {
  const currentUser = getStoredUser();
  if (!currentUser) return null;

  try {
    const res = await apiGet(`/api/daily-records/${dateStr}`);
    let fullRecord: DailyRecord | null = null;

    if (res.success && res.data) {
      const row = res.data;
      if (row.notes) {
        try {
          fullRecord = JSON.parse(row.notes);
        } catch (e) {}
      }

      if (!fullRecord) {
        fullRecord = createEmptyDailyRecord(dateStr);
        fullRecord.waterIntake = Number(row.water_intake_ml ?? 0);
        if (typeof row.notes === 'string') {
          fullRecord.notes.observations = row.notes;
        }
      } else {
        if (row.water_intake_ml !== undefined && row.water_intake_ml !== null) {
          fullRecord.waterIntake = Number(row.water_intake_ml);
        }
      }
    } else {
      fullRecord = createEmptyDailyRecord(dateStr);
    }

    // Also fetch individual nutrition entries directly from D1 to guarantee zero data loss
    try {
      const nutriRes = await apiGet('/api/nutrition', { date: dateStr });
      if (nutriRes.success && Array.isArray(nutriRes.data) && nutriRes.data.length > 0) {
        const cloudFoods: FoodItem[] = nutriRes.data.map((item: any) => ({
          id: item.id,
          name: item.food_name,
          category: (item.meal_type as any) || 'Lunch',
          quantity: item.portion || '۱ وعده',
          calories: Number(item.calories || 0),
          protein: Number(item.protein_g || 0),
          carbs: Number(item.carbs_g || 0),
          fat: Number(item.fat_g || 0),
          time: item.created_at ? new Date(item.created_at).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' }) : undefined
        }));

        const existingIds = new Set((fullRecord.foods || []).map(f => f.id));
        const mergedFoods = [...(fullRecord.foods || [])];
        for (const cf of cloudFoods) {
          if (!existingIds.has(cf.id)) {
            mergedFoods.push(cf);
            existingIds.add(cf.id);
          }
        }
        fullRecord.foods = mergedFoods;
      }
    } catch (nutriErr) {
      console.warn(`Failed fetching D1 nutrition entries for ${dateStr}:`, nutriErr);
    }

    const state = loadAppState();
    state.records[dateStr] = fullRecord;
    saveAppState(state, false);
    notifyDailyRecordUpdate(fullRecord);
    return fullRecord;
  } catch (err) {
    console.warn(`Failed syncing daily record for ${dateStr} from cloud:`, err);
  }
  return null;
}

export async function syncAllDailyRecordsFromCloud(): Promise<Record<string, DailyRecord>> {
  const currentUser = getStoredUser();
  if (!currentUser) return {};

  try {
    const res = await apiGet('/api/daily-records');
    if (res.success && Array.isArray(res.data)) {
      const recordsMap: Record<string, DailyRecord> = {};
      res.data.forEach((row: any) => {
        if (row && row.date) {
          let fullRecord: DailyRecord | null = null;
          if (row.notes) {
            try {
              fullRecord = JSON.parse(row.notes);
            } catch (e) {}
          }
          if (!fullRecord) {
            fullRecord = createEmptyDailyRecord(row.date);
            fullRecord.waterIntake = Number(row.water_intake_ml ?? 0);
            if (typeof row.notes === 'string') {
              fullRecord.notes.observations = row.notes;
            }
          } else {
            if (row.water_intake_ml !== undefined && row.water_intake_ml !== null) {
              fullRecord.waterIntake = Number(row.water_intake_ml);
            }
          }
          recordsMap[row.date] = fullRecord;
        }
      });

      if (Object.keys(recordsMap).length > 0) {
        const state = loadAppState();
        state.records = {
          ...state.records,
          ...recordsMap
        };
        saveAppState(state, false);
        return recordsMap;
      }
    }
  } catch (err) {
    console.warn('Failed syncing all daily records from cloud:', err);
  }
  return {};
}

// Update single record
export function saveDailyRecord(date: string, record: DailyRecord): void {
  const state = loadAppState();
  state.records[date] = record;
  saveAppState(state, false);
  notifyDailyRecordUpdate(record);

  const currentUser = getStoredUser();
  if (!currentUser) return;

  apiPost('/api/daily-records', {
    date,
    calories_target: state.settings.targetCalories || 2000,
    water_intake_ml: Math.max(0, Number(record.waterIntake || 0)),
    notes: JSON.stringify(record)
  }).catch(err => {
    console.warn(`Failed auto-syncing record for ${date} to cloud:`, err);
  });
}

// Generate reports functions

// Fetch a range of past records (e.g. last 7 days or last 30 days)
export function getRecordsRange(startDateStr: string, endDateStr: string): DailyRecord[] {
  const state = loadAppState();
  const recordsList: DailyRecord[] = [];
  
  const start = new Date(startDateStr);
  const end = new Date(endDateStr);
  
  // Loop days
  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const dateStr = d.toISOString().split('T')[0];
    const record = state.records[dateStr] || createEmptyDailyRecord(dateStr);
    recordsList.push(record);
  }
  return recordsList;
}

// Helper to determine weekday name (Persian Translated)
export function getWeekdayLabel(dateStr: string): string {
  const d = new Date(dateStr);
  const days = ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'];
  return days[d.getDay()];
}

// Calculate completion metrics for a single record (backward-compatible fallback)
export function getDailyScore(record: DailyRecord): number {
  if (!record) return 0;
  
  const totalRehab = DEFAULT_REHAB_EXERCISES.length;
  const compRehab = record.rehabCompletedIds?.length || 0;
  
  const totalFat = DEFAULT_FAT_LOSS_EXERCISES.length;
  const compFat = record.fatLossCompletedIds?.length || 0;
  
  const totalSwedish = DEFAULT_SWEDISH_TASKS.length;
  const compSwedish = record.swedishCompletedIds?.length || 0;
  
  // Proportional weight distribution
  const scoreRehab = totalRehab > 0 ? (compRehab / totalRehab) * 40 : 0;
  const scoreFat = totalFat > 0 ? (compFat / totalFat) * 25 : 0;
  const scoreSwedish = totalSwedish > 0 ? (compSwedish / totalSwedish) * 20 : 0;
  
  const scoreSchedule = (record.wentToWork ? 5 : 0) + (record.attendedSfi ? 5 : 0);
  const scoreWater = (record.waterIntake || 0) >= 1500 ? 10 : ((record.waterIntake || 0) / 1500) * 10;
  
  return Math.min(100, Math.round(scoreRehab + scoreFat + scoreSwedish + scoreSchedule + scoreWater));
}
